<div class="container-fluid" >
  <core-spinner *ngIf="isLoading"></core-spinner>

  <cli-landing-header></cli-landing-header>

  <div class="row">
    <div class="col-xl-2 col-lg-1 "></div>
    <div class="col-xl-2 col-lg-2 col-md-3  pt-4">
      <cli-landing-menu></cli-landing-menu>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-5 ">

      <div class="mt-2 mb-4 row">
        <div class="col welcome-text text-center">Email Validation</div>
      </div>


      <div *ngIf="isError"  class="alert alert-danger text-center">
         Sorry, we cannot recognise this Hydrotrak link
      </div>
      <div *ngIf="!isError && !isLoading"  class="success text-center">
        Email Address validated!

      </div>


    </div>
    <div class="col-xl-2 col-lg-2 col-md-3"></div>
    <div class="col-xl-2 col-lg-1 "></div>
  </div>


  <div style="padding-bottom:100px"></div>
  <cli-landing-footer></cli-landing-footer>

</div>
